import {
  generateDesktopSourcesForPicture,
  generateMobileSourcesForPicture,
} from '@farmersdog/corgi-x';
import BowlMobilePng from './bowl-mobile.png';
import BowlMobileWebp from './bowl-mobile.webp';
import BowlDesktopPng from './bowl-desktop.png';
import BowlDesktopWebp from './bowl-desktop.webp';
import GreenCheck from './green-check.svg';
import RedX from './red-x.svg';

export const bowlMobileSources = generateMobileSourcesForPicture({
  webP: BowlMobileWebp,
  png: BowlMobilePng,
});

export const bowlDesktopSources = generateDesktopSourcesForPicture({
  webP: BowlDesktopWebp,
  png: BowlDesktopPng,
});

export { GreenCheck, RedX };
